/**
 * Configuración global de la aplicación
 */

// 🌐 Dominio base de la aplicación
// Dominio personalizado configurado en Vercel
export const APP_DOMAIN = process.env.REACT_APP_DOMAIN || 'https://www.appagustinos.es';

// 📧 Email de contacto
export const CONTACT_EMAIL = 'pastoralapp@agustinos.es';

// 🔔 Configuración de notificaciones (preparado para Capacitor)
export const NOTIFICATIONS_CONFIG = {
  enabled: true,
  categories: [
    { id: 'buenos-dias', name: 'Buenos días', default: true },
    { id: 'evangelio', name: 'Evangelio del día', default: true },
    { id: 'vamos-al-cole', name: 'Vamos al cole', default: true },
    { id: 'vocaciones', name: 'Vocaciones', default: true },
    { id: 'eventos', name: 'Eventos especiales', default: true }
  ]
};

// 🎒 Tarjeta del Camino de Santiago en la pantalla de inicio
// Ya no se decide aquí: manda `mostrarCaminoHome` de public/app-config.json,
// que se puede cambiar desplegando la web, sin pasar por las tiendas. El valor
// por defecto vive en src/utils/remoteConfig.js.
// La ruta /camino sigue activa en cualquier caso, de modo que los enlaces ya
// compartidos continúan abriendo el contenido.

// 🔗 Información para compartir
export const SHARE_CONFIG = {
  siteName: 'Agustinos',
  defaultImage: '/logo512.png',
  defaultDescription: 'Agustinos - Siempre a tu lado'
};

